import React from 'react';
import './style.scss';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const TabsBox = ({ fields, rendering, activeTabName, sitecoreContext }) => {
  const isEditing = sitecoreContext && sitecoreContext.pageEditing;
  if (fields?.title?.value !== activeTabName.name && !isEditing) return null;
  return (
    <div
      data-e2e-class="styleguide-layout-tabs-tab"
      className={isEditing ? `btn-min-height` : null}
    >
      <Placeholder name="jss-tabItem" rendering={rendering} />
    </div>
  );
};

export default withSitecoreContext()(TabsBox);
